
  var _styles = {
  "containerWrap": {
    "paddingTop": "0.08rem",
    "paddingRight": 0,
    "paddingBottom": "0.08rem",
    "paddingLeft": 0,
    "position": "relative"
  },
  "cornerTagInfoContainer": {
    "width": "0.69333rem",
    "height": "0.82667rem",
    "position": "absolute",
    "left": "0.16rem",
    "top": 0,
    "zIndex": 1
  },
  "cornerTagInfoImg": {
    "width": "0.69333rem",
    "height": "0.82667rem"
  },
  "cornerTagRankNum": {
    "color": "rgb(255,255,255)",
    "fontFamily": "Meituan Digital Type",
    "fontWeight": "700",
    "fontSize": "0.33333rem",
    "lineHeight": "0.45333rem",
    "textAlign": "center",
    "marginTop": "0.24rem",
    "zIndex": 1,
    "position": "relative"
  },
  "container": {
    "display": "flex",
    "backgroundColor": "rgb(255,255,255)",
    "flexDirection": "column",
    "width": "4.16rem",
    "height": "7.41333rem",
    "marginLeft": 0,
    "borderRadius": "0.32rem",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "overflow": "hidden"
  },
  "frontImage": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "position": "relative"
  },
  "bottomImgTag": {
    "width": "100%",
    "position": "absolute",
    "bottom": 0,
    "left": 0,
    "zIndex": 1,
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "contentWrap": {
    "marginTop": "0.14667rem",
    "paddingTop": 0,
    "paddingRight": "0.24rem",
    "paddingBottom": 0,
    "paddingLeft": "0.24rem",
    "height": "4.74667rem",
    "width": "4.16rem",
    "position": "relative",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "titleWrap": {
    "width": "100%",
    "maxHeight": "1.09333rem"
  },
  "title": {
    "width": "100%",
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.37333rem",
    "color": "rgb(34,34,34)",
    "overflow": "hidden"
  },
  "positionWrap": {
    "display": "flex",
    "marginTop": "0.06667rem",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "positionInfo": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(102,102,102)",
    "letterSpacing": 0,
    "marginLeft": "0.08rem"
  },
  "recommendReason": {
    "maxWidth": "5rem",
    "fontWeight": "400",
    "color": "rgb(0,64,153)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem"
  },
  "tagListWrap": {
    "marginTop": "0.10667rem",
    "width": "100%",
    "height": "0.42667rem",
    "display": "flex",
    "flexDirection": "row",
    "overflow": "hidden",
    "flexWrap": "wrap"
  },
  "tag": {
    "height": "0.42667rem",
    "justifyContent": "center",
    "alignItems": "center",
    "background": "#e5ebf4",
    "borderRadius": "0.08rem",
    "paddingLeft": "0.08rem",
    "paddingRight": "0.08rem",
    "marginRight": "0.08rem"
  },
  "tagText": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(0,64,153)",
    "maxWidth": "2rem",
    "letterSpacing": 0
  },
  "giftListWrap": {
    "marginTop": "0.13333rem",
    "width": "100%",
    "height": "1.72rem"
  },
  "giftWrap": {
    "display": "flex",
    "height": "0.37333rem",
    "flexDirection": "row",
    "marginBottom": "0.13333rem",
    "alignItems": "center",
    "width": "100%"
  },
  "giftText": {
    "marginLeft": "0.10667rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(102,102,102)"
  },
  "buttonWrap": {
    "position": "absolute",
    "bottom": "0.37333rem",
    "height": "1.09333rem",
    "width": "100%",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "buttonBg": {
    "width": "3.68rem",
    "height": "1.09333rem"
  },
  "showOriginalPriceWrap": {
    "height": "100%",
    "marginLeft": "0.33333rem",
    "maxWidth": "3.92rem"
  },
  "notShowOriginalPriceWrap": {
    "height": "100%",
    "marginLeft": "0.33333rem",
    "maxWidth": "3.92rem",
    "marginTop": "0.22667rem"
  },
  "sellPriceWrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "pricePrefix": {
    "fontFamily": "MTfin-bold2.0",
    "fontSize": "0.32rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0
  },
  "price": {
    "fontFamily": "MTfin-bold2.0",
    "fontSize": "0.48rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0
  },
  "priceSuffix": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.29333rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0
  },
  "originalPrice": {
    "textDecoration": "line-through",
    "fontWeight": "400",
    "opacity": 0.8,
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.29333rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "textAlign": "left"
  },
  "discountInfoWrap": {
    "flexDirection": "row",
    "alignItems": "center"
  },
  "discountInfo": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)"
  }
};



  module.exports = _styles;
  